import * as React from "react";

export function DiscountNotificationIcon(
  props: React.SVGProps<SVGSVGElement> & { color: string },
): React.ReactElement {
  const { color, ...rest } = props;

  return (
    <svg width="15" height="15" viewBox="0 0 20 20" {...rest}>
      <circle cx={10} cy={10} r={10} fill={color} />
      <path
        d="M6.11 10.46c.688 0 1.229-.243 1.62-.73.397-.493.595-1.16.595-2.003V7.72c0-.839-.198-1.502-.595-1.99C7.34 5.243 6.798 5 6.11 5c-.688 0-1.23.244-1.627.731-.392.488-.587 1.151-.587 1.99v.007c0 .843.195 1.51.587 2.002.397.488.94.732 1.627.732zm0-.99c-.314 0-.558-.15-.731-.451-.169-.306-.253-.736-.253-1.292V7.72c0-.552.084-.978.253-1.279.173-.3.417-.45.731-.45.31 0 .552.15.725.45.173.301.26.727.26 1.279v.007c0 .556-.087.986-.26 1.292-.173.3-.415.45-.725.45zM7.34 15l6.666-9.864h-1.408L5.933 15H7.34zm6.481.137c.688 0 1.23-.244 1.627-.732.397-.492.595-1.157.595-1.996v-.007c0-.843-.198-1.508-.595-1.996-.396-.487-.939-.731-1.627-.731-.688 0-1.23.244-1.627.731-.392.488-.588 1.153-.588 1.996v.007c0 .839.196 1.504.588 1.996.397.488.94.732 1.627.732zm0-.992c-.31 0-.551-.15-.724-.45-.169-.306-.253-.734-.253-1.286v-.007c0-.556.084-.984.253-1.285.173-.3.414-.451.724-.451.315 0 .556.15.725.451.173.301.26.73.26 1.285v.007c0 .552-.087.98-.26 1.285-.169.301-.41.451-.725.451z"
        fill="#fff"
      />
    </svg>
  );
}
